import { apiFetch } from './client.ts';
import type { StatSnapshot, Unlock } from '@ricochet/achievements';

export interface UnlockedAchievement {
  achievementId: string;
  tier: number;
  unlockedAt: string;
  updatedAt: string;
}

export interface MyAchievementsResponse {
  unlocked: UnlockedAchievement[];
  snapshot: StatSnapshot;
}

export function getMyAchievements(token: string): Promise<MyAchievementsResponse> {
  return apiFetch('/api/achievements/me', { token });
}

export function notifyDiscordJoin(token: string): Promise<{ unlockedAchievements: Unlock[] }> {
  return apiFetch('/api/achievements/discord', { method: 'POST', token });
}
